import React from "react";
import { Modal } from "@wfp/ui";
import { useTranslation } from "react-i18next";

interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    danger?: boolean;
    loading?: boolean;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    danger = true,
    loading = false
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            modalHeading={title}
            modalLabel={title}
            primaryButtonText={confirmText || t('confirm')!}
            primaryButtonDisabled={loading}
            onRequestSubmit={onConfirm}
            onRequestClose={onCancel}
            secondaryButtonText={cancelText || t('cancel')!}
            secondaryButtonDisabled={loading}
            onSecondarySubmit={onCancel}
            danger={danger}
        >
            <p>{message}</p>
        </Modal>
    );
};
